import {createSelector} from "reselect";
import * as _ from "lodash";
import {getAllPowerSourcesData, getEnergyMixData, getPowerSourceLocationsData, getPowerSourcesData, IEnergyMixDictionary, IPowerSource} from "../../data/data";
import {countPowerSourcesByType, countPowerSourcesByID, getPopulatedPowerSources, getPowerSourceID, powerSources, countPowerSources} from "./powerSources";


/**
 * calculate and return the total energy mix
 */
export const getEnergyMix = createSelector(

    [countPowerSources, countPowerSourcesByType],

    (total_count: number, power_sources: IEnergyMixDictionary) : number =>
    {
        const ideal_mix: IEnergyMixDictionary = getEnergyMixData();

        // console.group('getEnergyMix');
        // console.log('total_count', total_count);
        // console.log('ideal_mix', ideal_mix);

        if (! total_count) return 0;

        const total_difference: number = _.reduce(ideal_mix, (sum: number, ideal_ratio: number, id: string = '') =>
        {
            const count: number = power_sources[id] || 0;
            const relative_pc: number = count / total_count / 0.01;
            const difference: number = ideal_mix[id] / relative_pc;
            const real_difference: number = _.isFinite(difference) ? difference : 0;
            const abs_difference: number = Math.abs(1 - Math.abs(real_difference));

            // console.group(id);
            // console.log('count', count);
            // console.log('relative_pc', relative_pc);
            // console.log('difference', difference);
            // console.log('abs_difference', abs_difference);
            // console.groupEnd();

            return sum + abs_difference;
            // return sum +

        }, 0);

        // console.log('sources', power_sources);
        // console.log('total_difference', total_difference);

        const n_sources: number = getAllPowerSourcesData().length;

        // console.log('n_sources', n_sources);
        // console.log('ratio', total_difference / n_sources);
        // console.log('1-ratio', 1 - total_difference / n_sources);
        // console.log('final result',  (1 - (total_difference / n_sources)) * 100);
        // console.groupEnd();


        return (1 - (total_difference / n_sources)) * 100;
    }
);


/**
 * get the difference between the ideal number of a power source type and the actual number in play
 */
export const getPowerSourceDifference = createSelector(

    [getPowerSourceID, countPowerSourcesByID],

    (power_source_id: string, power_source_count: number) : number =>
    {
        const ideal_mix: IEnergyMixDictionary = getEnergyMixData();

        return ideal_mix[power_source_id] - power_source_count;
    }
);


/**
 * get the difference in ideal/actual number of sources as a fraction
 */
export const getPowerSourceDifferenceRatio = createSelector(

    [getPowerSourceID, getPowerSourceDifference],

    (power_source_id: string, difference: number) : number =>
    {
        const ideal_mix: IEnergyMixDictionary = getEnergyMixData();

        return difference / ideal_mix[power_source_id];
    }
);


/**
 * get the difference in ideal/actual number of sources as a fraction
 */
export const getPowerSourceDifferenceRatios = createSelector(

    [countPowerSources, countPowerSourcesByType],

    (total_source_count: number,  populated_power_sources: { [id: string]: number }) : IEnergyMixDictionary =>
    {
        const power_sources: IPowerSource[] = getPowerSourcesData();
        const ideal_percentages: IEnergyMixDictionary = getEnergyMixData();
        const locations_count: number = getPowerSourceLocationsData().length;

        // console.group('getPowerSourceDifferenceRatios');
        // console.log('power_sources', power_sources);
        // console.log('populated_power_sources', populated_power_sources);
        // console.log('ideal_mix', ideal_percentages);
        //
        // // const total_source_count: number = _.sum(populated_power_sources);
        //
        // console.log('total_source_count', total_source_count);

        const ratios: IEnergyMixDictionary = _.transform(power_sources, (ratios: IEnergyMixDictionary, power_source: IPowerSource) =>
        {
            const id: string = power_source.id;
            const ideal_percentage: number = ideal_percentages[id];
            const ideal_count: number = Math.round(locations_count * ideal_percentage * 0.01);
            const actual_count: number = populated_power_sources[id] || 0;
            const difference: number = actual_count - ideal_count;
            const ratio: number = difference / ideal_count;

            ratios[id] = _.clamp(ratio, -1, 1);

            return ratios;

        }, {});

        // console.log('ratios', ratios);
        // console.groupEnd();

        return ratios;
    }
);


// WEBPACK FOOTER //
// ./src/ts/store/reducers/getEnergyMix.ts